import React from "react";

const PermissionsSubTabs = ({ activeSubTab, setActiveSubTab }) => {
  const subTabs = [
    { id: "forms", label: "Forms" },
    { id: "forms_content", label: "Forms content" },
    { id: "tools", label: "Tools" },
    { id: "reports", label: "Reports" },
    { id: "miscellaneous", label: "Miscellaneous" },
  ];

  return (
    <div className="flex gap-4 bg-white border-b-4 border-gray-200 relative">
      {subTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveSubTab(tab.id)}
          className={`pr-6 !pl-6 font-medium transition-colors flex items-center justify-center text-center text-gray-600 relative ${
            activeSubTab === tab.id
              ? "bg-white text-blue-600"
              : "hover:text-gray-800"
          }`}
        >
          {tab.label}
          {activeSubTab === tab.id && (
            <div className="absolute -bottom-1 left-0 right-0 h-1 bg-blue-600"></div>
          )}
        </button>
      ))}
    </div>
  );
};

export default PermissionsSubTabs;
